// 사무실 평면도(Office Map) — 좌석 좌표 고정 상수, 배정은 Employees.SeatId.
// 베란다 제거 + 좌측 정렬(캔버스 1040×600)으로 대회의실/연구소까지 모두 표시.
export const OFFICE_CANVAS = { w: 1040, h: 480 };
export const DESK_SIZE = { w: 104, h: 60 };
/** 가로형은 DESK_SIZE 그대로, 세로형은 가로/세로를 뒤바꾼 크기. */
export function deskSize(orientation) {
    return orientation === 'V' ? { w: DESK_SIZE.h, h: DESK_SIZE.w } : { w: DESK_SIZE.w, h: DESK_SIZE.h };
}
export const OFFICE_DESKS = [
    // 상단 벤치 (y 72)
    { id: 'D01', label: '#01', zone: '업무공간', x: 14, y: 72 },
    { id: 'D02', label: '#02', zone: '업무공간', x: 122, y: 72 },
    { id: 'D03', label: '#03', zone: '업무공간', x: 230, y: 72 },
    { id: 'D04', label: '#04', zone: '업무공간', x: 338, y: 72 },
    { id: 'D05', label: '#05', zone: '업무공간', x: 446, y: 72 },
    // 중간 벤치 (y 176)
    { id: 'D06', label: '#06', zone: '업무공간', x: 122, y: 176 },
    { id: 'D07', label: '#07', zone: '업무공간', x: 230, y: 176 },
    { id: 'D08', label: '#08', zone: '업무공간', x: 338, y: 176 },
    // 하단 벤치 (y 372)
    { id: 'D09', label: '#09', zone: '업무공간', x: 10, y: 372 },
    { id: 'D10', label: '#10', zone: '업무공간', x: 173, y: 372 },
    { id: 'D11', label: '#11', zone: '업무공간', x: 336, y: 372 },
    // 연구소 내부 (y 360)
    { id: 'R01', label: '연구1', zone: '연구소', x: 690, y: 360 },
    { id: 'R02', label: '연구2', zone: '연구소', x: 804, y: 360 },
    { id: 'R03', label: '연구3', zone: '연구소', x: 918, y: 360 },
];
// 연구소(lab)/소회의실: 높이 30%↓(254→178), 하단 맞춤(바닥 y464 고정 → top 286). 연구소 폭 = 대회의실(342).
export const OFFICE_ZONES = [
    { kind: 'lab', label: '연구소', x: 680, y: 286, w: 342, h: 178 },
];
export const MEETING_ROOMS = [
    { id: 'main', label: '대회의실', x: 680, y: 12, w: 342, h: 184 },
    // 소회의실: 폭 최대(하단 벤치 우측 끝~연구소 좌측 직전), 높이 178, 하단 맞춤
    { id: 'small', label: '소회의실', x: 448, y: 286, w: 222, h: 178 },
];
//# sourceMappingURL=office.js.map